import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Drawer from '@mui/material/Drawer';

import { styled } from '@mui/material/styles';
import React  from 'react';
import {  Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import ApplyForm from './ApplicationForm/ApplyForm';


const drawerWidth = 0;

const Main = styled('main', { shouldForwardProp: prop => prop !== 'open' })(({ theme, open }) => ({
  flexGrow: 1,
  transition: theme.transitions.create('margin', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginRight: -drawerWidth,
  ...(open && {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: 0,
  }),
}));



export default function PersistentDrawerRight() {
 
  

  

  return (
    <Router>
      <Box sx={{ display: 'flex', width: '100%' }}>
        <CssBaseline />
        
        <Main >
          
          <Routes>
           <Route path="/" element={<ApplyForm />} />
          </Routes>
         
        </Main>
        <Drawer
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            '& .MuiDrawer-paper': {
              width: drawerWidth,
            },
          }}
          variant="persistent"
          anchor="right"
          open={true}
        >
         
        </Drawer>
      </Box>
    </Router>
  );
}

//b4855a